export const getApiDataWithPost = (
    url: string,
    postData: any,
    setLoading: (loading: boolean) => void,
    setData: (data: any) => void,
    setErrorMessage: (errorMessage: string) => void) => {

    fetch(url, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            pragma: "no-cache"
        },
        body: JSON.stringify(postData)
    })
        .then(response => {
            if (!response.ok) {
                response.text().then(text => {
                    if (text !== "")
                        setErrorMessage(text);
                    else
                        setErrorMessage("Fetch failed (" + response.statusText + ").");
                });
            } else {
                response.json().then(data => {
                    setData(data);
                });
            }
            setLoading(false);
        })
        .catch(error => {
            setErrorMessage(error.message);
            setLoading(false);
        });

}

